import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ChevronDown from 'react-icons/lib/fa/chevron-down';
// import ChevronUp from 'react-icons/lib/fa/chevron-up';
import { getTheColor } from '../utils/helpers';
// import BrandName from './BrandName';

const mutDefs = {
  rt: {
    label: 'RT (Reverse Transcriptase | NRTIs & NNRTIs) Drug Resistance Interpretation',
    short: 'RT'
  },
  pr: {
    label: 'PR (Protease Inhibitors | PI) Drug Resistance Interpretation',
    short: 'PI'
  },
  in: {
    label: 'IN (Integrase Inhibitors | INSTI) Drug Resistance Interpretation',
    short: 'IN'
  }
};

class ResistanceReport extends Component {
  static propTypes = {
    drugResistances: PropTypes.array.isRequired,
    mutations: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      version: ''
    };
  }

  render() {
    return (
      <div className="c-page">
        <Link to="/" className="c-button c-button--icon">
          <svg viewBox="0 0 40 40">
            <path d="M32.7,16.05H20v-5.5h0a2.6,2.6,0,0,0-2.75-2.4,2.76,2.76,0,0,0-1.79.72L3.07,20,15.46,31.13a2.81,2.81,0,0,0,3.77,0A2.44,2.44,0,0,0,20,29.45V24H32.7A4.1,4.1,0,0,0,36.93,20a4.1,4.1,0,0,0-4.23-3.95Z" />
          </svg>
          <span>Back</span>
        </Link>
        <p className="c-page__p c-page__p--padded-left">This report was generated using the Stanford HIVdb. <a className="c-page__link" href="https://hivdb.stanford.edu/">Learn More</a></p>
        <p className="c-page__p c-page__p--padded-left">For assistance in interpreting these results, get in touch with a specialist.</p>
        {this.props.drugResistances && this.props.drugResistances.map((item, i) => {
          return (
            <div key={i} className="c-report-section">
              {item.gene && <h1>{mutDefs[item.gene.name.toLowerCase()].label}</h1>}
              <div className="c-card c-card--theme-white">
                <h2 className="c-card__heading c-card__heading--lg">{mutDefs[item.gene.name.toLowerCase()].short} & Dosing Considerations</h2>
                <table className="c-card__table">
                  <thead>
                    <tr>
                      <th>Drug</th>
                      <th>Generic Name</th>
                      {/* <th>Brand Name</th> */}
                      <th>Resistance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.drugScores.map((ds, d) => (
                      <tr key={d} className={`${getTheColor(ds.text)}`}>
                        <td>{ds.drug.name}</td>
                        <td className="h-capitalize">{ds.drug.fullName.replace(/\/r$/, '')}</td>
                        {/* <td><BrandName drugName={ds.drug.fullName} /></td> */}
                        <td>{ds.text}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {!!item.commentsByTypes
                  .filter(c => c.commentType === 'Dosage').length &&
                  <h3 className="c-card__heading c-card__heading--md">Dosage Considerations</h3>}
                {item.commentsByTypes
                  .filter(c => c.commentType === 'Dosage')
                  .map((cbt, c) => (cbt.comments.map((cmt, z) => <p className="c-card__text" key={z}>{cmt.text}</p>)))}
              </div>
  
              <div className="c-card c-card--theme-white">
                <h2 className="c-card__heading c-card__heading--lg">{mutDefs[item.gene.name.toLowerCase()].short} Mutations</h2>
                <div className="c-accordion">
                  {item.mutationsByTypes
                    .filter((mbt) => !!mbt.mutations.length)
                    .map((mbt, m) => (
                      <div key={m} className="c-accordion__row">
                        <label htmlFor={`${item.gene.name}-${m}`} className="c-accordion__header">
                          <h4 className="c-accordion__heading">{`${mbt.mutationType} Resistance`}</h4>
                          <ul className="c-accordion__inline-list">
                            {mbt.mutations.map((mu, u) => (<li key={u}>{mu.text}</li>))}
                          </ul>
                          <ChevronDown className="c-accordion__chevron" />
                        </label>
                        <input className="c-accordion__checkbox" type="checkbox" id={`${item.gene.name}-${m}`} />
                        <div className="c-accordion__body">
                          {item.commentsByTypes
                            .filter((cbt) => cbt.commentType === mbt.mutationType)
                            .map((cbt, c) => (
                              <div key={c}>
                                {cbt.comments.length &&
                                  <ul className="c-accordion__list">
                                    {cbt.comments.map((cmt, z) => <li key={z}>{cmt.text}</li>)}
                                  </ul>}
                              </div>
                            ))}
                        </div>
                      </div>
                    ))}
                  {!!item.drugScores.length && 
                    <div className="c-accordion__row">
                      <label htmlFor={`${item.gene.name}-mutation-scoring`} className="c-accordion__header">
                        <h4 className="c-accordion__heading">Mutation Scoring</h4>
                        <ChevronDown className="c-accordion__chevron" />
                      </label>
                      <input className="c-accordion__checkbox" type="checkbox" id={`${item.gene.name}-mutation-scoring`} />
                      <div className="c-accordion__body">
                        <table className="c-card__table">
                          <thead>
                            <tr>
                              <th>{mutDefs[item.gene.name.toLowerCase()].short}</th>
                              {item.drugScores.map((ds) => {
                                return <th key={ds.drug.displayAbbr}>{ds.drug.displayAbbr}</th>;
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {Object
                              .keys(this.props.mutations[item.gene.name.toLowerCase()])
                              .map((mut) => {
                                return (
                                  <tr key={mut}>
                                    <td>{mut}</td>
                                    {item.drugScores.map((ds) => {
                                      return <td key={ds.drug.displayAbbr}>{ds.score}</td>;
                                    })}
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default ResistanceReport;



// WEBPACK FOOTER //
// ./src/components/ResistanceReport.js